import type { Division } from '../core/constants/divisions';

/**
 * More divisions than this and the switcher's panel offers a search, as
 * Paper's location panel does past six options: fifteen rows is a list to
 * read, not to scan.
 */
export const DIVISION_SEARCH_THRESHOLD = 6;

/** Lower case, accents dropped, spaces collapsed: "Ricoh España" finds "espana". */
function normalise(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * The divisions whose name holds every word of the query. An empty query
 * keeps them all, as they were. The hierarchy's order is kept; a match's depth
 * is dropped (`depth: 0`), since its parent may be filtered out and an indent
 * under nothing reads as a mistake.
 */
export function filterDivisions(divisions: readonly Division[], query: string): readonly Division[] {
  const words = normalise(query).split(' ').filter(Boolean);
  if (!words.length) return divisions;
  return divisions
    .filter((d) => {
      const name = normalise(d.name);
      return words.every((w) => name.includes(w));
    })
    .map((d) => ({ ...d, depth: 0 }));
}
